import { render, staticRenderFns } from "./mail-wizz-selector.vue?vue&type=template&id=0e5bc44f&"
import script from "./mail-wizz-selector.ts?vue&type=script&lang=js&"
export * from "./mail-wizz-selector.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports